import { PDFViewer, ProviderClaimPayment, ProviderDocumentUrl, Spinner } from '@enter/core';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { IObservedRootStore } from 'stores';
import * as S from './claim-timeline-table.styles';

interface IPaymentDetailProps extends IObservedRootStore {
    payment: ProviderClaimPayment;
}

export const PaymentDetail: React.FunctionComponent<IPaymentDetailProps> = inject('rootStore')(
    observer((props: IPaymentDetailProps) => {
        const { payment, rootStore } = props;
        if (!rootStore) {
            return <></>;
        }

        const [loading, setLoading] = useState(false);
        const [documentUrl, setDocumentUrl] = useState<ProviderDocumentUrl | undefined>();

        useEffect(() => {
            (async (): Promise<void> => {
                if (!payment.id) {
                    return;
                }

                setLoading(true);

                const url = await rootStore.claimStore.loadPaymentDownloadUrl(payment.id);
                setDocumentUrl(url);

                setLoading(false);
            })();
        }, [payment]);

        const renderDocument = () => {
            if (documentUrl?.url) {
                return <PDFViewer url={documentUrl.url} />;
            }
        };

        return (
            <S.ExpandWrap key={payment.id}>
                {loading ? <Spinner /> : <S.ExpandContainer>{renderDocument()}</S.ExpandContainer>}
            </S.ExpandWrap>
        );
    }),
);
